import * as React from "react";
import Skeleton from "@mui/material/Skeleton";

export default function AllBrandsPageSkeleton() {
  return (
    <div className="all-brands-wrapper" >
      <Skeleton width="20%" variant="text" sx={{ fontSize: "1rem" }} />
      <div className="brand-search" style={{marginTop:"70px"}}>
        <Skeleton width="50%" variant="text" sx={{ fontSize: "1rem" }} />
        <Skeleton width="10%" variant="text" sx={{ fontSize: "1rem" }} />
      </div>
      <div style={{display:"flex", flexWrap:"wrap", gap:"40px", marginTop:"20px"}}>
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
        <Skeleton
          animation="wave"
          sx={{ bgcolor: "grey.300" }}
          variant="rounded"
          width={270}
          height={200}
        />
      
      </div>
    </div>
  );
}
